import script from "./limitLoginForm.vue?vue&type=script&setup=true&lang=js"
export * from "./limitLoginForm.vue?vue&type=script&setup=true&lang=js"

import "./limitLoginForm.vue?vue&type=style&index=0&id=5d69dd80&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d69dd80"]])

export default __exports__